module.exports = __webpack_public_path__ + "img/1.6f2064f2.png";